<template>
    <div class="q-my-md row-group">
        <div class="container">
            <h2 v-html="title"></h2>
        </div>

        <v-row v-for="(row, i) in rows" :key="i" :is-video="isVideo"
               :title="row.title" :uri="row.uri" :layout="row.layout" :items="row.items"/>
    </div>
</template>

<script>
    export default {
        name: 'VRowGroup',

        props: {
            title: {
                type: String,
                required: true
            },
            rows: {
                type: Array,
                required: true
            },
            isVideo: Boolean,
            isHome: Boolean
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/RowGroup.vue